module.exports = __webpack_public_path__ + "img/video-in-home.c24dcc80.svg";